import store from '@/store';
import { transactionRepository } from '@/forms/api/repository-factory';
import callApi from '@/lib/helpers/call-api';
import FIELD_NAMES from '@/forms/constants/field-names';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';

import {
  SET_TRANSACTION_ID,
  SET_SERVICE_STATUS,
} from '@/lib/constants/mutations';

import PERFIOS_TRANSACTION from '@/lib/constants/store';

import {
  START_TRANSACTION,
  END_TRANSACTION,
  SERVICE_STATUS,
} from '@/forms/constants/services';

import checkServiceStatus from '@/lib/helpers/check-service-status';

const hasServiceEnded = serviceName => checkServiceStatus(serviceName) === SERVICE_STATUS.success;

export default {
  startTransaction: async (step, callbacks) => {
    const { appId, formData: { values } } = store.state;
    const { form } = step;

    if (hasServiceEnded(START_TRANSACTION)) {
      return true;
    }

    let serviceStatus = SERVICE_STATUS.fail;

    const response = await callApi({
      callbacks,
      form,
      formElement: step,
      apiCall: transactionRepository.startTransaction,
      payload: {
        'app-id': appId,
        'institution-id': getValueByFieldName(values, FIELD_NAMES.bankAccount),
      },
    });

    if (response) {
      serviceStatus = SERVICE_STATUS.success;

      store.commit(SET_TRANSACTION_ID, {
        duniaIncomeVerificationId: response['dunia-income-verification-id'],
        vendorIncomeVerificationId: response['vendor-income-verification-id'],
      });
    }

    store.commit(SET_SERVICE_STATUS, {
      service: START_TRANSACTION,
      status: serviceStatus,
    });

    return !!response;
  },

  completeTransaction: async (step, callbacks) => {
    const { appId } = store.state;
    const {
      duniaIncomeVerificationId,
      vendorIncomeVerificationId,
    } = store.state.formData[PERFIOS_TRANSACTION];
    const { form } = step;

    if (hasServiceEnded(END_TRANSACTION)) {
      return true;
    }

    const response = await callApi({
      callbacks,
      form,
      formElement: step,
      apiCall: transactionRepository.completeTransaction,
      payload: {
        'app-id': appId,
        'dunia-income-verification-id': duniaIncomeVerificationId,
        'vendor-income-verification-id': vendorIncomeVerificationId,
      },
    });

    let serviceStatus = SERVICE_STATUS.fail;

    if (response) {
      serviceStatus = SERVICE_STATUS.success;
      store.commit(SET_SERVICE_STATUS, {
        service: END_TRANSACTION,
        status: serviceStatus,
      });
    }

    return !!response;
  },
};
